import styled from "styled-components";

export const HelpStyled = styled.div`
    .help-main{
        margin-top: 50px;

        .help-list{

            .help-item{
                margin-top: 45px;

                .help-top{
                    border-bottom: 1px solid #00000030;
                    display: flex;
                    justify-content: space-between;
                    padding-bottom: 12px;
                    h3{
                        font-weight: 400;
                        font-size: 24px;
                        line-height: 36px;
                    }
                    span{
                        font-size: 32px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.2s ease-in;
                        &.active{
                            transform: rotate(135deg);
                        }
                    }

                    p{
                        margin: 12px;
                        font-size: 20px;
                    }
                }
            }
            @media (max-width: 576px) {
                .help-item{
                    margin-top: 25px;
                    .help-top{
                        padding-bottom: 5px;
                        align-items: center;
                        h3{
                            font-size: 14px;
                            line-height: 18px;
                        }
                        span{
                            font-size: 24px;
                        }
                    }
                    .help-text{
                        font-size: 12px !important;
                        line-height: 16px !important;
                        margin: 12px 0 !important;
                    }
                }
            }
        }
    }
`